// Externals
import React from "react";
import { useSelector } from "react-redux";
import Header from "../components/Header";
import Header2 from "../components/Header2";

import { useDesktop } from "../utils/useDesktop";
import "./Profile.scss";

const Profile = () /*: React.Component */ => {
	const params = new URLSearchParams(window.location.search);
	const sid = params.get("sid");

	const isDesktop = useDesktop();
	const props = useSelector((state) => state.matches.matches[sid]);
	let imagePath = typeof(props?.image[0]?.image_path) === 'undefined' ?
		'/wp-content/uploads/2024/12/noPhotoFound.png' :
		'/wp-content/uploads/animals/' + props?.image[0]?.image_path;

	return (
		<div className="profile-screen">
			{console.log(props)}
			<Header />
			<Header2 />
			<div className="profile-screen-container">
				<div className="profile-screen-content">
					<div>
						<button
							onClick={() => window.history.back()}
							className="btn"
						>
							&lt; Back to previous
						</button>
						<div
							className="pet-profile"
							style={{
								flexDirection: isDesktop ? "row" : "column",
							}}
						>
							<div className="pet-name">{props.name}</div>
							<div className="pet-image-container">
								<img
									src={imagePath}
									alt="pet-profile-img"
									width="100%"
								/>
							</div>
							<div className="pet-details-container">
								<div className="pet-id">
									Animal ID:{props.id}
								</div>
								<div className="breed">Breed:</div>
								<div>{props.breed_primary}</div>
								<div className="checks">
									<div className="check-item">
										<div
											style={{
												fontSize: "2rem",
												color: "rgb(0, 153, 204)",
												margin: "0.5rem",
											}}
										>
											<i className="fas fa-heartbeat"></i>
										</div>
										health
										<div
											style={{
												fontSize: "2rem",
												color: "#7db956",
												margin: "0.5rem",
											}}
										>
											<i className="fas fa-check-square"></i>
										</div>
									</div>
									<div className="check-item">
										<div
											style={{
												fontSize: "2rem",
												color: "rgb(0, 153, 204)",
												margin: "0.5rem",
											}}
										>
											<i className="fas fa-microchip"></i>
										</div>
										microchip
										<div
											style={{
												fontSize: "2rem",
												color: "#7db956",
												margin: "0.5rem",
											}}
										>
											<i className="fas fa-check-square"></i>
										</div>
									</div>
									<div className="check-item">
										<div
											style={{
												fontSize: "2rem",
												color: "rgb(0, 153, 204)",
												margin: "0.5rem",
											}}
										>
											<i className="fas fa-bug"></i>
										</div>
										worming
										<div
											style={{
												fontSize: "2rem",
												color: "#7db956",
												margin: "0.5rem",
											}}
										>
											<i className="fas fa-check-square"></i>
										</div>
									</div>
									<div className="check-item">
										<div
											style={{
												fontSize: "2rem",
												color: "rgb(0, 153, 204)",
												margin: "0.5rem",
											}}
										>
											<i className="fas fa-venus-mars"></i>
										</div>
										desexing
										<div
											style={{
												fontSize: "2rem",
												color: "#7db956",
												margin: "0.5rem",
											}}
										>
											<i className="fas fa-check-square"></i>
										</div>
									</div>
								</div>
								<div className="details">
									<div className="detail-container">
										<div className="detail-id">Age:</div>
										<div className="detail-value">{props.age_for_adoption}</div>
									</div>
									<div className="detail-container">
										<div className="detail-id">Sex:</div>
										<div className="detail-value">
											{props.sex}
										</div>
									</div>

									<div className="detail-container">
										<div className="detail-id">Size:</div>
										<div className="detail-value">
											{props.size}
										</div>
									</div>
									<div className="detail-container">
										<div className="detail-id">Type:</div>
										<div className="detail-value">Dog</div>
									</div>

									<div className="detail-container">
										<div className="detail-id">Color:</div>
										<div className="detail-value">
											{props.primary_colour}
										</div>
									</div>
									<div className="detail-container">
										<div className="detail-id">
											Location:
										</div>
										<div className="detail-value">
											{props.shelter_name}
										</div>
									</div>

									<div className="detail-container">
										<div className="detail-id">RON</div>
										<div className="detail-value">
											{props.ron}{" "}
											<div className="tooltip">
												<i className="fas fa-question-circle"></i>
												<span className="tooltiptext">
													RON refers to Rehoming
													Organisation Number
												</span>
											</div>
										</div>
									</div>
								</div>
								<div
									className="button-container"
									style={{
										marginTop: "2rem",
										display: "flex",
										flexWrap: "wrap",
										justifyContent: "space-around",
									}}
								>
									<button
										style={{
											margin: "0.25rem",
											fontSize: "1rem",
											padding: "1rem 2.5rem",
										}}
									>
										Meet {props.name}
									</button>
									<button
										style={{
											background: "#0098CB",
											margin: "0.25rem",
											fontSize: "1rem",
											padding: "1rem 2.5rem",
										}}
									>
										Donate now
									</button>
								</div>
							</div>
						</div>
						<div className="pet-copy-container">
							<div className="header-text">
								Little bit about {props.name}
							</div>
							<div
								className="pet-copy"
								style={{
									columnCount: isDesktop ? "2" : 1,
								}}
								dangerouslySetInnerHTML={{__html: props.adoption_summary}}
							>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

// Exports
export default Profile;
